import { useContext } from 'react';
import { DownloadContext } from './DownloadManagerContext';

export const useDownloadManager = () => useContext(DownloadContext);
